import { createContext, useContext } from 'react';
export const AskInputPlusMenuFileInputContext = createContext(null);
AskInputPlusMenuFileInputContext.displayName = 'AskInputPlusMenuFileInputContext';
export function useAskInputPlusMenuFileInput() {
    const context = useContext(AskInputPlusMenuFileInputContext);
    if (!context) {
        throw new Error('useAskInputPlusMenuFileInput must be used within AskInputPlusMenuFileInputProvider');
    }
    return context;
}
//# sourceMappingURL=AskInputPlusMenuProviderShared.js.map